import { render, staticRenderFns } from "./SettingHE.vue?vue&type=template&id=1a8d8ee0&"
import script from "./SettingHE.vue?vue&type=script&lang=js&"
export * from "./SettingHE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports